module.exports = __webpack_public_path__ + "static/assets/a17f2230aad2fa1ee95f861ed04ec822.jpg";